enum DashboardTopCategoryType {
    SALES = 'Sales',
    RETENTION = 'Retention',
}

export default DashboardTopCategoryType;
